module.exports = __webpack_public_path__ + "img/logo s-pedido-redu.fw.98f902b1.png";